import React from 'react'
import { Hero } from './Hero'
import { ProductsSlideshow } from './ProductsSlideshow'
import { colors } from 'utils/colors'
import { IHeroCarouselImages } from '../../../graphql/types'

export type HomePageHeroProps = {
  title: string
  images: IHeroCarouselImages
}

export const HomePageHero = ({ title, images }: HomePageHeroProps) => {
  return (
    <Hero backgroundColor={colors.primary} title={title}>
      <ProductsSlideshow images={images} />
    </Hero>
  )
}
